export const CREATE_PROPERTY_RULESET_BANNER_ANALYTICS = {
  shown: 'repo_custom_properties_suggestions.ruleset_banner.shown',
  clicked: 'repo_custom_properties_suggestions.ruleset_banner.clicked',
  dismissed: 'repo_custom_properties_suggestions.ruleset_banner.dismissed',
  propertyCreated: 'repo_custom_properties_suggestions.ruleset_banner.property_created',
} as const
